import React from 'react';

export enum TabVariant {
  Default = 'default',
  Segmented = 'segmented'
}

export interface TabItem {
  label: string;
  value: string;
  flag?: string;
  icon?: React.ReactNode;
  showDeleteIcon?: boolean;
  showEditIcon?: boolean;
  dataTour?: string;
}

export interface TabsComponentProps {
  value: string;
  variant?: TabVariant;
  segmentedCompact?: boolean;
  tabs: TabItem[];
  onChange: (event: React.SyntheticEvent, newValue: string) => void;
  disabled?: Record<string, boolean>;
  onDelete?: (tab: TabItem) => void;
  onEdit?: (tab: TabItem) => void;
}
